// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body,html{height:100%;font-size:14px;line-height:30px}*{outline:none}ul li{list-style:none;padding:0;margin:0}a{text-decoration:none}.fl{float:left}.fr{float:right}.clear{clear:both}input::-ms-clear{display:none}", ""]);
// Exports
module.exports = exports;
